import React from 'react'
import HomeBanner from './home/HomeBanner'
import HomeAbout from './home/HomeAbout'
import HomeServices from './home/HomeServices'
import OurFleets from './home/OurFleets'
import HowWork from './home/HowWork'
import WatchFullVideo from './home/WatchFullVideo'
import WhyChooseUs from './home/WhyChooseUs'
import HomeTestimonial from './home/HomeTestimonial'
import HomeBlog from './home/HomeBlog'


const Home = () => {
  return (
    <>
      <HomeBanner />
      <HomeAbout />
      <HowWork />
      <HomeBlog />
      {/* <HomeTestimonial />
      <HomeServices />
      <WatchFullVideo /> */}
      {/* <WhyChooseUs /> */}
      <OurFleets />
      <HomeTestimonial />


    </>
  )
}

export default Home